import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import axios from '../../../../constents/axios';

const DeleteSubTopics = ({ show, onHide, topicName, subTopicName, courseName, onSuccess }) => {
    const handleDeleteSubTopic = async () => {
        try {
            await axios.delete(`/delete-subtopic`, {
                data: {
                    course_id: courseName,
                    topics: topicName,
                    subtopic: subTopicName
                }
            });
            onSuccess(); 
            onHide(); 
        } catch (error) {
            console.error('Error deleting topic and subtopic:', error);
        }
    };

    return (
        <Modal show={show} size="lg" backdrop="static" onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">Delete SubTopic</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <span>Deleting this SubTopic could wipe out everything else attached to it, like a digital domino effect.</span>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Cancel</Button>
                <Button variant="danger" onClick={handleDeleteSubTopic}>Delete SubTopic</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeleteSubTopics;
